export function getRuntimeConfig() {
    return {
        smartformClientId: process.env.SMARTFORM_CLIENT_ID ?? null,
        gtmId: process.env.GTM_ID ?? null,
        gtmCustomParams: process.env.GTM_CUSTOM_PARAMS ?? null,
        ga4MeasurementId: process.env.GA4_MEASUREMENT_ID ?? null,
        metaPixelId: process.env.META_PIXEL_ID ?? null,
        seznamRtgId: process.env.SEZNAM_RTG_ID ?? null,
        analyticsEvents: {
            seznamConversion: process.env.SEZNAM_CONVERSION_ID ?? null,
        },
    };
}
